/**
 * @class MenuItem
 */
export default class MenuItem {
    /**
     * @param {String}  name
     * @param {String}  type
     * @param {Boolean} visible
     * @param {String}  defaultText
     * @param {String}  parent
     * @param {Array}   items
     */
    constructor(name, type, visible, defaultText, parent, items) {
        this._name = name;
        this._type = type;
        this._visible = visible;
        this._defaultText = defaultText;
        this._parent = parent;
        this._items = items;

        if (typeof this._name !== "string") {
            throw new Error("Invalid datatype of name");
        }
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get type() {
        return this._type;
    }

    /**
     * @param {String} type
     */
    set type(type) {
        this._type = type;
    }

    /**
     * @return {Boolean}
     */
    get visible() {
        return this._visible;
    }

    /**
     * @param {Boolean} visible
     */
    set visible(visible) {
        this._visible = visible;
    }

    /**
     * @return {String}
     */
    get defaultText() {
        return this._defaultText;
    }

    /**
     * @param {String} defaultText
     */
    set defaultText(defaultText) {
        this._defaultText = defaultText;
    }

    /**
     * @return {String}
     */
    get parent() {
        return this._parent;
    }

    /**
     * @param {String} parent
     */
    set parent(parent) {
        this._parent = parent;
    }

    /**
     * @return {Array}
     */
    get items() {
        return this._items;
    }

    /**
     * @param {Array} items
     */
    set items(items) {
        this._items = items;
    }

    /**
     * @return {String}
     */
    toString() {
        return "MenuItem (" + this._id + ")";
    }
}
